import FilterNav from '../../molecules/filterNav/FilterNav';
import Slider from '../../atoms/slider/Slider';
import styles from './PriceMobileItem.module.scss';
const AirtimeMobileItem = (props) => {

	const onSliderChange = (value) => {
		props.selectAirtimeMobile(value)
	}
	return (
		<div className={styles.navGutter}>
			<FilterNav headingName='Airtime' 
						backbtn={props.hideAirtimeMob} 
						resetClickHandler={props.resetClickHandler} 
						selectedFilter={props.selectedFilter}/>
			<div className={styles.priceContainer}>
				<div className={styles.slider}>
					<Slider sliderChange={(value) => onSliderChange(value)} label1 = "R"
						minValue={props.minValue}
						maxValue={props.maxValue}
						min={props.min} max={props.max}
						rightLabel =""
						sliderType ="airtime"
						/>
				</div>
			</div>
		</div>
	);
};

export default AirtimeMobileItem
